import { useEffect, useState, useRef } from "react";
import { useField } from "formik";
import TextEditor, {
  htmlToDraftBlocks,
  convertToHTML,
} from "components/TextEditor";

const FormikTextEditor = ({ name, ...rest }) => {
  const [field, meta, helpers] = useField({ name });

  const [content, setContent] = useState(htmlToDraftBlocks());
  const prevContent = useRef(content);

  useEffect(() => {
    const html = convertToHTML(content);

    if (html !== prevContent.current) {
      prevContent.current = html;

      helpers.setValue(html);
    }
  }, [content, helpers]);

  return (
    <TextEditor
      {...rest}
      {...field}
      {...meta}
      content={content}
      setContent={setContent}
      hideActions
    />
  );
};

export default FormikTextEditor;
